import '../assets/src/main.js';

import '../assets/css/banners.css';
import '../assets/css/bussines-plans.css';
import '../assets/css/common.css';
import '../assets/css/gallery.css';
import '../assets/css/items.css';
import '../assets/css/main.css';
import '../assets/css/modal.css';
import '../assets/css/publish.css';
import '../assets/css/slider.css';
import '../assets/css/stars.css';
import '../assets/css/switch.css';
import '../assets/css/user.css';

console.log('App cargada');
